export default "__VITE_ASSET__Bdtleham__"